import { makeBreakpoints } from '@utils/css';

/**
 * core breakpoints defined for shared components to streamline the way we
 * write responsive UI
 *
 * it is recommended to use these breakpoints outside the monorepo as well,
 * although you are also free to create custom breakpoint collections whenever
 * it is needed to meet business requirements - e.g. a custom implemented
 * header or footer
 */

const breakpoints = makeBreakpoints({
  mobile: 0,
  tablet: 768,
  desktop: 1024
});

export { breakpoints };
//# sourceMappingURL=breakpoints.js.map
